import { render, staticRenderFns } from "./albumSelector.vue?vue&type=template&id=51441552&"
import script from "./albumSelector.vue?vue&type=script&lang=js&"
export * from "./albumSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports